var $checkoutZahlungsartForm = $(".js-checkout_zahlungsart_form");
$(function(){
    isSubmit = false;

    if($checkoutZahlungsartForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($checkoutZahlungsartForm.find(".js-form_successblock"), 5000);
    }

    $checkoutZahlungsartForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

        if(isSubmit && typeof isSubmit != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmit = true;

        var validSubmit = false;

        $.each($checkoutZahlungsartForm.find(".js-form_input"), function(key, value){
            if($(this).prop("checked") == true){
                validSubmit = true;
            }
        });

        if(validSubmit){
            showLoader();

            $.ajax({
                url:$(this).data("ajax"),
                data: $checkoutZahlungsartForm.serialize(),
                type:"POST",
                dataType: "json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmit = false;

                if(response.valid){
                    $checkoutZahlungsartForm.trigger('submit');
                }else{
                    formMsgBlockSetText($checkoutZahlungsartForm.find(".js-form_errorblock"), response.error)
                    formMsgBlockShow($checkoutZahlungsartForm.find(".js-form_errorblock"));
                }

                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmit = false;
            formMsgBlockShow($checkoutZahlungsartForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});